<div *ngIf="visitPlan" class="layout-row full-height">
  <bringoz-icon iconName="info-outline"
                class="secondary-101"
                [ngbTooltip]="tooltipTmpl"
                openDelay="300" placement="right-top" container="body">

  </bringoz-icon>

  <ng-template #tooltipTmpl>
    <div class="layout-column gap-5">

      <!-- Creator -->
      <div class="layout-row layout-align-start-center gap-5">
        <span class="br-body-2">{{ 'Creator' | translate }}: {{ visitPlan.creator || visitPlan.createdBy?.name }}</span>
        <span *ngIf="visitPlan.createdAt" class="br-body-2">- {{ visitPlan | bringozFullDate: 'createdAt' }} {{ visitPlan | bringozTime: 'createdAt' }}</span>
      </div>

      <!-- Subtitle -->
      <div *ngIf="visitPlan.description"
           class="layout-row layout-align-start-center gap-5">
        <span class="br-body-2">{{ 'Subtitle' | translate }}:</span>
        <span class="br-body-2">{{ visitPlan.description }}</span>
      </div>

      <!-- Time Zone -->
      <div class="layout-row layout-align-start-center gap-5">
        <span class="br-body-2">{{ 'Time Zone' | translate }}:</span>
        <span class="br-body-2">{{ visitPlan.zoneId }}</span>
      </div>

      <!-- Service Time Provider -->
      <div *ngIf="visitPlan.visitPlanConfig" class="layout-row layout-align-start-center gap-5">
        <span class="br-body-2">{{ 'Service Time Provider' | translate }}:</span>
        <span
          class="br-body-2">{{ 'VISIT_SLOT_SERVICE_TIME_PROVIDERS.' + (visitPlan.visitPlanConfig.visitSlotProviderTypeRegistry.visitSlotServiceTimeProviderType[0]) | translate }}</span>
      </div>

      <!-- Units Provider -->
      <div *ngIf="visitPlan.visitPlanConfig"  class="layout-row layout-align-start-center gap-5">
        <span class="br-body-2">{{ 'Units Provider' | translate }}:</span>
        <span class="br-body-2">{{ 'VISIT_SLOT_UNITS_PROVIDERS.' + (visitPlan.visitPlanConfig?.visitSlotProviderTypeRegistry?.visitSlotUnitsProviderType[0]) | translate }}</span>
      </div>

      <!-- Delivery Time Provider -->
      <div *ngIf="visitPlan.visitPlanConfig"  class="layout-row layout-align-start-center gap-5">
        <span class="br-body-2">{{ 'Delivery Time Provider' | translate }}:</span>
        <span
          class="br-body-2">{{ 'VISIT_SLOT_DELIVERY_TIME_PROVIDERS.' + (visitPlan.visitPlanConfig?.visitSlotProviderTypeRegistry?.visitSlotDeliveryTimeProviderType[0]) | translate }}</span>
      </div>

      <!-- Branch Groups -->
      <div *ngIf="visitPlan.groupReferences?.length"
           class="layout-row layout-align-start-center gap-5 margin-bottom-5">
        <bringoz-icon iconName="group"></bringoz-icon>
        <app-bringoz-items-list-display class="flex"
                                        [itemsList]="{list: visitPlan.groupReferences, displayKey: 'name'}"
                                        [maxItems]="5">

        </app-bringoz-items-list-display>
      </div>

      <!-- Branches -->
      <div class="layout-row layout-align-start-center gap-5">
        <bringoz-icon iconName="branch"></bringoz-icon>
        <app-bringoz-items-list-display class="flex"
                                        [itemsList]="{list: visitPlan.branchReferences, displayKey: 'name'}"
                                        [maxItems]="5">

        </app-bringoz-items-list-display>
      </div>

    </div>
  </ng-template>
</div>


<!--<div class="margin-left-5">-->
<!--  <bringoz-icon icon-name="info-outline" class="secondary-101"></bringoz-icon>-->
<!--  <md-tooltip md-direction="bottom" md-delay="500" class="bringoz-tooltip">-->
<!--    <div layout="column">-->

<!--      &lt;!&ndash; Creator &ndash;&gt;-->
<!--      <div layout="row" layout-align="start center" class="gap-5">-->
<!--        <span class="br-body-2">{{ 'Creator' | translate }}:</span>-->
<!--        <span class="br-body-2">{{ $ctrl.visitPlan.createdBy.name }}</span>-->
<!--        <span class="br-body-2">- {{ $ctrl.visitPlan | bringozFullDate: 'createdAt' }} {{ $ctrl.visitPlan | bringozTime: 'createdAt' }}</span>-->
<!--      </div>-->

<!--      &lt;!&ndash; Subtitle &ndash;&gt;-->
<!--      <div ng-if="$ctrl.visitPlan.description"-->
<!--           layout="row" layout-align="start center" class="gap-5">-->
<!--        <span class="br-body-2">{{ 'Subtitle' | translate }}:</span>-->
<!--        <span class="br-body-2">{{ $ctrl.visitPlan.description }}</span>-->
<!--      </div>-->

<!--      &lt;!&ndash; Time Zone &ndash;&gt;-->
<!--      <div layout="row" layout-align="start center" class="gap-5">-->
<!--        <span class="br-body-2">{{ 'Time Zone' | translate }}:</span>-->
<!--        <span class="br-body-2">{{ $ctrl.visitPlan.zoneId }}</span>-->
<!--      </div>-->

<!--      &lt;!&ndash; Service Time Provider &ndash;&gt;-->
<!--      <div layout="row" layout-align="start center" class="gap-5">-->
<!--        <span class="br-body-2">{{ 'Service Time Provider' | translate }}:</span>-->
<!--        <span-->
<!--          class="br-body-2">{{ 'VISIT_SLOT_SERVICE_TIME_PROVIDERS.' + $ctrl.visitPlan.visitPlanConfig.visitSlotProviderTypeRegistry.visitSlotServiceTimeProviderType[0] | translate }}</span>-->
<!--      </div>-->

<!--      &lt;!&ndash; Units Provider &ndash;&gt;-->
<!--      <div layout="row" layout-align="start center" class="gap-5">-->
<!--        <span class="br-body-2">{{ 'Units Provider' | translate }}:</span>-->
<!--        <span-->
<!--          class="br-body-2">{{ 'VISIT_SLOT_UNITS_PROVIDERS.' + $ctrl.visitPlan.visitPlanConfig.visitSlotProviderTypeRegistry.visitSlotUnitsProviderType[0] | translate }}</span>-->
<!--      </div>-->

<!--      &lt;!&ndash; Delivery Time Provider &ndash;&gt;-->
<!--      <div layout="row" layout-align="start center" class="gap-5">-->
<!--        <span class="br-body-2">{{ 'Delivery Time Provider' | translate }}:</span>-->
<!--        <span-->
<!--          class="br-body-2">{{ 'VISIT_SLOT_DELIVERY_TIME_PROVIDERS.' + $ctrl.visitPlan.visitPlanConfig.visitSlotProviderTypeRegistry.visitSlotDeliveryTimeProviderType[0] | translate }}</span>-->
<!--      </div>-->

<!--      &lt;!&ndash; Branch Groups &ndash;&gt;-->
<!--      <div ng-if="$ctrl.visitPlan.groupReferences"-->
<!--           layout="row" layout-align="start center" class="gap-5 margin-bottom-5">-->
<!--        <bringoz-icon icon-name="group"></bringoz-icon>-->
<!--        <bringoz-items-list-display flex-->
<!--                                    items-list="{list: $ctrl.visitPlan.groupReferences, displayKey: 'name'}"-->
<!--                                    max-items="5">-->

<!--        </bringoz-items-list-display>-->
<!--      </div>-->

<!--      &lt;!&ndash; Branches &ndash;&gt;-->
<!--      <div layout="row" layout-align="start center" class="gap-5">-->
<!--        <bringoz-icon icon-name="branch"></bringoz-icon>-->
<!--        <bringoz-items-list-display flex-->
<!--                                    items-list="{list: $ctrl.visitPlan.branchReferences, displayKey: 'name'}"-->
<!--                                    max-items="5">-->

<!--        </bringoz-items-list-display>-->
<!--      </div>-->

<!--    </div>-->
<!--  </md-tooltip>-->
<!--</div>-->
